export default __webpack_public_path__ + "images/ansys-cecp_black.png";